var map = {
	"./Actionplan.vue": "8510",
	"./Decision.vue": "6386",
	"./Entry.vue": "7184",
	"./Health.vue": "b3b5",
	"./Improve.vue": "95da",
	"./Mybonehealth.vue": "2a7c",
	"./Notes.vue": "be82",
	"./Quiz.vue": "e1eb",
	"./Record.vue": "1d30",
	"./Results.vue": "32e7",
	"./Risk.vue": "4f63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c40";